import type { ApolloCache } from '@apollo/client'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

import { updatePostScheduledTimeCache } from './updatePostScheduledTimeCache'

export const RemoveCalendarPostScheduledTime = graphql(/* GraphQL */ `
  mutation RemoveCalendarPostScheduledTime(
    $input: RemovePostScheduledTimeInput!
  ) {
    removePostScheduledTime(input: $input) {
      __typename
      ... on MutationError {
        message
      }
      ... on PostActionSuccess {
        post {
          id
          dueAt
          status
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useRemovePostScheduledTime = () =>
  useTypedMutation(
    RemoveCalendarPostScheduledTime,
    (data) => data.removePostScheduledTime,
    {
      successTypename: 'PostActionSuccess',
      update: (
        cache: ApolloCache,
        {
          data,
        }: {
          data?: ResultOf<typeof RemoveCalendarPostScheduledTime> | null
        },
      ) => {
        if (data?.removePostScheduledTime.__typename !== 'PostActionSuccess') {
          return
        }

        updatePostScheduledTimeCache(cache, {
          id: data.removePostScheduledTime.post.id,
          dueAt: null,
          status: data.removePostScheduledTime.post.status,
          isCustomScheduled: false,
          isPinned: false,
        })
      },
    },
  )
